import { DateTimeHelper, DateTimeType } from "../utils/date-time-helper";

export class OdometerReading {
  RecordId?: number;

  Id?: number;
  CreatedBy?: number;
  CreatedDate?: string;
  ModifiedBy?: number;
  ModifiedDate?: string;
  ActivityLogId?: number;

  // Base
  UserId: number;
  Date: string;
  ActivityLogRecordId: number;
  OdometerStart: number;
  OdometerEnd?: number;
  IsDeleted: boolean;
  StartPhotoBlobName?: string;
  EndPhotoBlobName?: string;

  constructor(obj?: Partial<OdometerReading>) {
    if (obj) {
      Object.assign(this, obj);
    }
    else {
      throw Error('Object cannot be null');
    }
  }

  clone(): OdometerReading {
    return new OdometerReading(this);
  }

  get Mileage(): number | null {
    if (!this.OdometerEnd) {
      return null;
    }
    return this.OdometerEnd - this.OdometerStart;
  }

  get IsClosed(): boolean {
    return !!this.OdometerEnd;
  }

  setOdometerStart(odometerStart: number): void {
    this.OdometerStart = odometerStart;
  }

  setOdometerEnd(odometerEnd: number | null): void {
    this.OdometerEnd = odometerEnd;
  }

  setActivityLog(activityLogRecordId: number, activityLogId: number): void {
    this.ActivityLogRecordId = activityLogRecordId;
    this.ActivityLogId = activityLogId;
  }

  setSoftDeleted(): void {
    this.IsDeleted = true;
  }

  isSoftDeleted(): boolean {
    return this.IsDeleted;
  }
}
